<template>
  <div class="slider">
    <div class="slide active" v-for="item in 3" :key="item">
      <img src="@/assets/images/slider/slider-1.png" alt="" />
      <div class="info">
        <h2>
          {{ $t("wr1.slider.title") }}
        </h2>
        <p>
          {{ $t("wr1.slider.sub_title") }}
        </p>
      </div>
    </div>

    <div class="navigation">
      <div class="prev-btn" @click="prevBtn">
        <img src="@/assets/images/icons/chevron-left.svg" alt="" />
      </div>
      <div class="next-btn" @click="nextBtn">
        <img src="@/assets/images/icons/chevron-right.svg" alt="" />
      </div>
    </div>
    <div class="navigation-visibility">
      <div class="slide-icon active"></div>
      <div class="slide-icon"></div>
      <div class="slide-icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "slider",
  data() {
    return {
      slideNumber: 0,
      playSlider: "",
    };
  },
  mounted() {
    this.repeater();
  },
  methods: {
    nextBtn() {
      const slides = document.querySelectorAll(".slide");
      const slideIcons = document.querySelectorAll(".slide-icon");
      const numberOfSlides = slides.length;
      slides.forEach((slide) => {
        slide.classList.remove("active");
      });
      slideIcons.forEach((slideIcon) => {
        slideIcon.classList.remove("active");
      });
      this.slideNumber++;
      if (this.slideNumber > numberOfSlides - 1) {
        this.slideNumber = 0;
      }
      slides[this.slideNumber].classList.add("active");
      slideIcons[this.slideNumber].classList.add("active");
    },

    prevBtn() {
      const slides = document.querySelectorAll(".slide");
      const slideIcons = document.querySelectorAll(".slide-icon");
      const numberOfSlides = slides.length;
      slides.forEach((slide) => {
        slide.classList.remove("active");
      });
      slideIcons.forEach((slideIcon) => {
        slideIcon.classList.remove("active");
      });
      this.slideNumber--;
      if (this.slideNumber < 0) {
        this.slideNumber = numberOfSlides - 1;
      }
      slides[this.slideNumber].classList.add("active");
      slideIcons[this.slideNumber].classList.add("active");
    },

    repeater() {
      const slides = document.querySelectorAll(".slide");
      const slideIcons = document.querySelectorAll(".slide-icon");
      const numberOfSlides = slides.length;
      this.playSlider = setInterval(
        function () {
          slides.forEach((slide) => {
            slide.classList.remove("active");
          });
          slideIcons.forEach((slideIcon) => {
            slideIcon.classList.remove("active");
          });
          this.slideNumber++;

          if (this.slideNumber > numberOfSlides - 1) {
            this.slideNumber = 0;
          }

          slides[this.slideNumber].classList.add("active");
          slideIcons[this.slideNumber].classList.add("active");
        }.bind(this),
        9000
      );
    },
  },
};
</script>



<style lang="scss" scoped>
.slider {
  width: 100%;
  height: 100vh;
  position: relative;

  .slide {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    clip-path: circle(0% at 0 50%);
  }
  .active {
    clip-path: circle(150% at 0 50%);
    transition: 2s;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .info {
      position: absolute;
      top: 60%;
      left: 50%;
      width: 100%;

      transform: translate(-50%);
      @media (min-width: 1008px) {
        width: 73%;
      }

      padding: 20px;
      border-radius: 5px;

      box-shadow: 0 5px 25px rgb(1 1 1 / 5%);
      color: #fff;

      text-align: center;
      h2 {
        color: #fff;

        font-size: 2.5em;
        font-weight: 800;
        margin-bottom: 30px;
      }
      p {
        font-size: 1em;
        font-weight: 400;
      }
    }
  }
  .navigation {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 1;
    transition: opacity 0.5s ease;
    .prev-btn,
    .next-btn {
      z-index: 10;
      color: #222;
      padding: 30px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100px;
        object-fit: cover;
      }
    }
  }
  .navigation-visibility {
    z-index: 999;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 88%;
    left: 50%;
    transform: translate(-50%);
    .slide-icon {
      z-index: 999;
      background: rgba(255, 255, 255, 0.5);
      width: 10px;
      height: 10px;
      /* transform: translateY(-50px); */
      margin: 0 6px;
      border-radius: 50px;
      box-shadow: 0 5px 25px rgb(1 1 1 / 20%);
    }
    .active {
      background: #4285f4;
    }
  }
}

@media (max-width: 900px) {
  .slider {
    width: 100%;
  }

  .slider .slide .info h2 {
    font-size: 1.5em;
  }
  .slider .slide .info p {
    font-size: 0.5em;
  }
}

/* @media (max-width: 500px) {
  .slider .slide .info h2 {
    font-size: 1.8em;
    line-height: 40px;
  }

  .slider .slide .info p {
    font-size: 0.9em;
  }
} */
</style>